import { z } from "zod"

import { CountryIso3166Schema } from "./enum"

export const prodSiteSchema = z.object({
  name: z.string().trim().regex(new RegExp("[^s]")),
  address: z
    .string({ required_error: "Address is required" })
    .trim()
    .regex(new RegExp("[^s]")),
  countryIso3166: CountryIso3166Schema,
  certificates: z.array(
    z.object({
      type: z.string(),
    })
  ),
})

export type prodSiteValidationType = z.infer<typeof prodSiteSchema>
